import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/moulds',
    name: 'POST_MODULE',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
